// Pace = time ÷ distance, shown on cardio/carry results so coaches read effort
// at a glance. Distance in m → pace per 100m; km → per km; mi → per mi.

export function parseClock(t) {
  if (t == null) return null;
  const s = String(t).trim();
  if (!s) return null;
  if (s.includes(":")) {
    const parts = s.split(":");
    const m = parseInt(parts[0], 10) || 0;
    const sec = parseInt(parts[1], 10) || 0;
    return m * 60 + sec;
  }
  const n = parseFloat(s);
  return Number.isNaN(n) ? null : n;
}

export function fmtClock(totalSec) {
  const s = Math.round(totalSec);
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, "0")}`;
}

// Returns a display string like "0:50 / 100m", or null when not computable.
export function formatPace(timeStr, distance, unit) {
  const secs = parseClock(timeStr);
  const d = parseFloat(distance);
  if (!secs || !d || d <= 0) return null;
  const u = (unit || "m").toLowerCase();
  if (u === "m") return `${fmtClock(secs / (d / 100))} / 100m`;
  if (u === "km") return `${fmtClock(secs / d)} / km`;
  if (u === "mi") return `${fmtClock(secs / d)} / mi`;
  return null;
}
